import { __decorate, __extends } from "tslib";
import { CustomElement, upgradeProperty } from '@tyler-components-web/core';
import { OPTION_GROUP_CONSTANTS } from './option-group-constants';
/**
 * The custom element class behind the `<tcw-option-group>` element.
 */
var OptionGroupComponent = /** @class */ (function (_super) {
    __extends(OptionGroupComponent, _super);
    function OptionGroupComponent() {
        return _super.call(this) || this;
    }
    Object.defineProperty(OptionGroupComponent, "observedAttributes", {
        get: function () {
            return [
                OPTION_GROUP_CONSTANTS.attributes.LABEL
            ];
        },
        enumerable: true,
        configurable: true
    });
    OptionGroupComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'label');
    };
    OptionGroupComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case OPTION_GROUP_CONSTANTS.attributes.LABEL:
                this.label = newValue;
                break;
        }
    };
    Object.defineProperty(OptionGroupComponent.prototype, "label", {
        /** Gets/sets the label of this option group. */
        get: function () {
            return this._label;
        },
        set: function (value) {
            if (this._label !== value) {
                this._label = value || '';
                this.setAttribute(OPTION_GROUP_CONSTANTS.attributes.LABEL, this._label);
            }
        },
        enumerable: true,
        configurable: true
    });
    OptionGroupComponent = __decorate([
        CustomElement({
            name: OPTION_GROUP_CONSTANTS.elementName
        })
    ], OptionGroupComponent);
    return OptionGroupComponent;
}(HTMLElement));
export { OptionGroupComponent };
